module.exports = __webpack_public_path__ + "static/media/hk.2f704d25.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/hk.svg
// module id = 2108
// module chunks = 0